<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Computer Education</h4>
                  <div class="card-body text-center">
                     <p class="inner-lead">The importance of computer skills in today's society cannot be overstated. In fact, it is difficult to imagine any profession or industry that doesn't require some level of computer proficiency. At our school, we recognize this reality and have made it our mission to equip our students with the knowledge and skills they need to excel in the digital age.
                    </p>
                    <p class="inner-lead">In today's digital age, students need to have a strong foundation in computer skills to prepare them for the future. At our school, we believe that computer education is essential for success in the modern world. We are committed to providing our students with the best possible education in computer skills and preparing them for a bright future.
                    </p>
                    <p class="inner-lead">We believe that our commitment to computer education will give our students a competitive edge in the job market and set them up for success in whatever career path they choose. By providing our students with the tools and knowledge they need to navigate the digital landscape with confidence, we are empowering them to achieve their dreams and make a positive impact on the world.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>